/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    FIND_ASSIGNABLE_ASSETS_FOR_ADDON,
    SortDirectionEnum,
} from '@gripp/shared-logic';
import { AssignmentListGrid } from '@gripp/shared-ui';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAddonAssetColumns } from './useAddonAssetColumns';

export type AddonAssetsAssignmentListProps = {
  workspaceId: string;
  addonId: string;
  maxHeight?: number;
  keyword?: string;
  assignments: string[];
  updateAssignments: (assignments: string[]) => void;
};

export const AddonAssetsAssignmentList = ({
  workspaceId,
  addonId,
  maxHeight,
  keyword,
  assignments,
  updateAssignments,
}: AddonAssetsAssignmentListProps) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<any>(() => {
    if (assignments && workspaceId) {
      return {
        keyword,
        addonId,
        assignments,
        workspaceId,
      };
    }
    return undefined;
  });
  const columns = useAddonAssetColumns() as ColumnDef<any, any>[];

  useEffect(() => {
    setFilter({
      keyword,
      addonId,
      assignments,
      workspaceId,
    });
    // `assignments` intentionally excluded: id-selection keeps the picked rows
    // regardless of the filter, so re-fetching on every toggle is unnecessary.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword, addonId, workspaceId]);

  if (!filter) return null;

  return (
    <AssignmentListGrid
      modelName="asset"
      query={FIND_ASSIGNABLE_ASSETS_FOR_ADDON}
      dataPrefix="addon.findAssignableAssetsForAddon"
      columns={columns}
      filter={filter}
      assignments={assignments}
      onAssignmentsChange={updateAssignments}
      maxHeight={maxHeight}
      textEmpty={t('assets.textEmpty')}
      orderBy={{ field: 'name', order: SortDirectionEnum.Asc }}
    />
  );
};
